<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Time Ranges</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="timeRangeNew()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueService.subscriptionTimeRanges.value"
		[loading]="!venueService.subscriptionTimeRanges.value"
		[globalFilterFields]="app.keys(venueService.subscriptionTimeRanges.value)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Name</th>
				<th>Active</th>
				<th>Active Dates</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="timeRangeSelected = rec">
				<td>{{ rec.name }}</td>
				<td>
					<fa-icon *ngIf="rec.active" [icon]="['far', 'check']"></fa-icon>
				</td>
				<td>
					<span *ngIf="rec.startDate && rec.endDate">
						<div class="d-flex flex-column">
							<div>Starts: {{ moment(rec.startDate).format("l") }}</div>
							<div>Ends: {{ moment(rec.endDate).format("l") }}</div>
						</div>
					</span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog *ngIf="timeRangeSelected" [(visible)]="timeRangeSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'clock']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">{{ timeRangeSelected.name || "New Time Range" }}</div>
		</div>
		<p-divider></p-divider>
	</ng-template>
	<app-time-range-setup
		#timeRangeForm
		[timeRangeSelected]="timeRangeSelected"
		(clearEmitter)="timeRangeSelected = undefined"
		(saveEmitter)="timeRangeSave($event)"
	></app-time-range-setup>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			(onCancelChange)="timeRangeSelected = undefined"
			(onDeleteChange)="timeRangeDelete(timeRangeSelected)"
			(onSaveChange)="timeRangeSave(timeRangeSelected)"
			[cancelDisabled]=""
			[deleteDisabled]="timeRangeSelected.isFromPos"
			[saveDisabled]="timeRangeSelected.isFromPos || timeRangeSelected.name"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
